import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpSentEvent, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class MohHttpInterceptorService implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const customReq = req.clone({
      headers: req.headers.set('app-language', 'it')
    });

    // pass on the modified request object
    return next.handle(customReq)

      .do((ev: HttpEvent<any>) => {

        if (ev instanceof HttpResponse) {
          //console.log('processing response', ev);
        }
      })

      .catch(response => {

        if (response instanceof HttpErrorResponse) {
          //console.log('Processing http error', response);
        }

        return Observable.throw(response);
      });
  }
}
(function (open) {
  XMLHttpRequest.prototype.open = function () {
    this.addEventListener("readystatechange", function () {
      if (this.responseURL) {
        if ((this.responseURL).includes("FileUpload")) {
          if (this.status != 0 && this.status != 200) {
            console.log("XHR Processing http error", this.status, this.response)
          }
          else if (this.status == 200 && this.readyState == 4) {
            console.log('XHR processing response', this.response);
          }
        }
      }
    }, false);
    open.apply(this, arguments);
  };
})(XMLHttpRequest.prototype.open);




// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/services/general/moh-http-interceptor.service.ts